/**
 * @file   我的点赞
 * @create macaiqi 2021/12/03
 * @update
 */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Pager } from '@portal-site/pager';
import usePage from '../../../components/Hooks/usePage';
import { htmltoStr } from '../../../../utils'
import { Select, message } from 'antd';
import { apiqueryCollectionList, apiDelCollection, } from '../../../shared/api';
// import { set } from 'core-js/library/fn/dict';
import Default from '@/assets/images/desktop/common/default.jpg';
const pre = window.ENV_IMG_PREURL_SRC;

const DoStar = () => {
  const { Option } = Select;
  const [data, setData] = useState();
  const [time, setTime] = useState('');
  const [search, setSearch] = useState()
  const [val, setVal] = useState()

  function handleChange(value) {
    setTime(value);
  }

  const [initPage, setPage] = usePage(1);
  const params = useMemo(() => {
    return {
      name: search,
      type: 1, // 类型 0点赞 1点赞
      current: initPage,
      size: 8,
      timeDistance: time,// 0 近一周 ； 1 近半个月 ； 2 近一个月
    }
  }, [time, initPage, search])

  useEffect(() => {
    getData(params);
  }, [params]);

  const getData = (param) => {
    apiqueryCollectionList(param).then((res) => {
      if(res.records){
        res.records.forEach(el => {
          if(el.instanceModel && el.instanceModel.files.length>0){
            el['showImage'] = pre +'/'+ el.instanceModel.files[0].fileThumbnail;
          }
          if(el.startNodeName && el.endNodeName){
            el['operationName'] = '关系图谱';
            el['name'] = el.startNodeName+'和'+el.endNodeName+'的关系路径';
            el['path'] = '/Relation?startsearch='+el.startNodeName+'&endsearch='+el.endNodeName;
          }else{
            if(el.fileInfoId){
              el['operationName'] = '影像探索';
              el['name'] = el.instanceModel?.instanceName;
              el['path'] = '/PicturelistPage/'+el.instanceModel?.instanceId+'?fileInfoId='+el.fileInfoId;
            }else{
              el['operationName'] = '知识百科';
              el['name'] = el.instanceModel?.instanceName;
              el['path'] = '/Subject/'+el.instanceModel?.conceptCode+'/'+el.instanceModel?.instanceId;
            }
          }
        })
      }
      setData(res);
    });
  }

  const confirm = (relationId) => {
    apiDelCollection(relationId).then((res) => {
      if (res) {
        setPage(1);
        getData(params);
        message.success('取消点赞成功');
      } else {
        message.error('取消点赞失败')
      }
    });
  }
  const handleKeyDown = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        e.preventDefault();
        setSearch(val)

      }
    },
    [val]
  );
  const handClick = () => {
    setSearch(val)
  }
  return (
    <div className="personal-common">
      <div className='p-head'>
        <div className="p-title">点赞记录</div>
        <div className="topbar">
          <Select defaultValue="" style={{ width: 130 }} onChange={handleChange}>
            <Option value="">全部</Option>
            <Option value="0">近一周</Option>
            <Option value="1">近半个月</Option>
            <Option value="2">近一个月</Option>
          </Select>
          {/* <div className="collect-search">
            <input type="text" placeholder='请输入点赞名称' value={val || ""} onChange={(e) => {
              setVal(e.target.value);
            }} onKeyDown={handleKeyDown} />
            <i className='iconfont icon-sousuo' onClick={() => {
              handClick()
            }} />
          </div> */}
        </div>
      </div>
      <div className="collection-box">
        <section className="collection-img">
          {
            data?.records?.map((item, index) => {
              return (
                <Link to={item.path} target="_blank" className="collection-item" key={index}>
                  <div className="item-l">
                    <img src={item.showImage ? item.showImage : Default}/>
                  </div>
                  <div className='item-r'>
                    <div className='closeBtn' onClick={(e) => {
                      e.preventDefault()
                      confirm(item?.relationId)
                    }}>×</div>
                    <p className='title'>
                      <span title={item.name}>{item.name}</span>
                      <span>{item.operationName}</span>
                    </p>
                    <p className='nums'>
                      <span><i className='iconfont icon-shoucang'/>{item.likeNum || 0}</span>
                      <span><i className='iconfont icon-good'/>{item.num || 0}</span>
                    </p>
                  </div>
                </Link>
              )
            })
          }
          <div className='clearfix'/>
          {/* {data?.records?.map((item, index) => {
            return (
              <Link to={`/Subject/${item?.instanceModel?.conceptCode}/${item?.instanceId}`} className="item" key={index}>
                <div className="title">
                  {item?.instanceModel?.instanceName}
                </div>
                <p className="des">
                  {htmltoStr(item?.instanceModel?.properties?.description)}
                </p>
                <div className="del" onClick={(e) => {
                  e.preventDefault()
                  confirm(item?.relationId)
                }}>
                  <i className='iconfont icon-guanbi' />
                </div>
              </Link>
            )
          })} */}
        </section>
        {data?.total > 1 && (
          <Pager
            containerClassName="mypager"
            forcePage={initPage || 1}
            pageCount={data?.pages}
            // total={data?.total}
            onPageChange={(page) => setPage(page)}
            // showLast={false}
            // showFirst={false}
            prevLabel="上一页"
            nextLabel="下一页"
          // showTotal
          />
        )}
        {data && data?.total === 0 && <div className="collection-empty">
          <div className="img" />
          <p>暂无点赞</p>
          <Link to="/">再去看看吧~</Link>
        </div>}
      </div>
    </div>
  )
}

export default DoStar;
